import Category from '@common/models/Category';
import { isMobile } from '@common/utils';
import SectionHeading from '@components/SectionHeading';
import AspectRatio from '@lib/AspectRatio';
import Link from '@lib/Link';
import classnames from 'classnames';
import React, { useState } from 'react';

interface CategoryCardProps {
  categories: Category;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ categories, heading }) => {
  const [Hover, SetHover] = useState(null);
  const leftCategories = [];
  const rightCategories = [];
  if (categories.length >= 5) {
    leftCategories.push(categories[0]);
    leftCategories.push(categories[2]);
    rightCategories.push(categories[1]);
    rightCategories.push(categories[3]);
    rightCategories.push(categories[4]);
  }
  if (categories.length === 4) {
    leftCategories.push(categories[0]);
    leftCategories.push(categories[2]);
    rightCategories.push(categories[1]);
    rightCategories.push(categories[3]);
  }
  if (categories.length === 3) {
    leftCategories.push(categories[0]);
    rightCategories.push(categories[1]);
    rightCategories.push(categories[2]);
  }
  if (categories.length === 2) {
    leftCategories.push(categories[0]);
    rightCategories.push(categories[1]);
  }
  if (categories.length === 1) {
    leftCategories.push(categories[0]);
  }
  return (
    <div className="category-showcase-container layout-container container mx-auto py-40 overflow-x-hidden">
      <SectionHeading className={'mb-34 text-center'}>{heading}</SectionHeading>
      <div id="categories" className="category-2 cs-3 category-card-row md:flex justify-center">
        <div
          style={{ flex: '1 1 54.12%' }}
          className="w-full md:mr-30 px-20 md:px-0 flex flex-col gap-30 mb-30 md:mb-0"
        >
          {leftCategories.map((category) => (
            <AspectRatio
              key={category.id}
              aspectRatio={(() => {
                if (isMobile()) {
                  return 358 / 230;
                }
                switch (true) {
                  case categories.length <= 2:
                    return 698 / 300;
                  case categories.length === 3:
                    return 698 / 564;
                  case categories.length === 4:
                    return 698 / 270;
                  case categories.length >= 5:
                    return 698 / 360;
                  default:
                    break;
                }
              })()}
            >
              <Link key={category.id} to={category.storeLink} className="w-full">
                <div className="category-card zoomIn relative rounded-md overflow-hidden h-full w-full">
                  <div className="category-img h-full">
                    <img
                      className="object-cover overflow-hidden rounded-md h-full w-full transform hover:scale-105"
                      src={category.homePageLambdaImage}
                      alt={category.name}
                      style={
                        Hover === category.id
                          ? { transform: 'scale(1.2)', transition: '0.6s' }
                          : { transform: 'scale(1)', transition: '0.6s' }
                      }
                    />
                  </div>
                  <div
                    className="category-text top-0 p-30 md:p-40 w-full left-0 bg-overlayBg absolute flex items-center justify-center md:justify-start md:items-end h-full rounded-md overflow-hidden"
                    onMouseEnter={() => SetHover(category.id)}
                    onMouseLeave={() => SetHover(null)}
                  >
                    <div>
                      <h3
                        className="text-white leading-28 text-28 font-extrabold text-center md:text-left w-full"
                        font-customisation="para-text"
                        color-customisation="page-body-text"
                      >
                        {category.name}
                      </h3>
                    </div>
                  </div>
                </div>
              </Link>
            </AspectRatio>
          ))}
        </div>

        <div style={{ flex: '1 1 448px' }} className="w-full px-20 md:px-0 flex flex-col gap-30">
          {rightCategories.map((category) => (
            <div
              style={{ paddingBottom: isMobile() ? `${(230 / 335) * 100}%` : 0 }}
              key={category.id}
              className="relative h-full w-full"
            >
              <div className="absolute inset-0 h-full w-full">
                <Link to={category.storeLink} className="w-full h-full">
                  <div
                    className={classnames('category-card zoomIn rounded-md relative overflow-hidden w-full h-full', {})}
                  >
                    <div className="relative h-full w-full">
                      <img
                        className="object-cover overflow-hidden rounded-md  transform hover:scale-105 absolute inset-0 w-full h-full"
                        src={category.homePageLambdaImage}
                        alt={category.name}
                        style={
                          Hover === category.id
                            ? { transform: 'scale(1.2)', transition: '0.6s' }
                            : { transform: 'scale(1)', transition: '0.6s' }
                        }
                      />
                    </div>
                    <div
                      className="category-text top-0 p-30 md:p-40 left-0 absolute bg-overlayBg flex items-center justify-center h-full w-full md:justify-start md:items-end rounded-md overflow-hidden"
                      onMouseEnter={() => SetHover(category.id)}
                      onMouseLeave={() => SetHover(null)}
                    >
                      <div>
                        <h4
                          className="text-white leading-28 text-28 font-extrabold text-center md:text-left w-full"
                          font-customisation="para-text"
                          color-customisation="page-body-text"
                        >
                          {category.name}
                        </h4>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;
